import { apiClient } from "api";
import { WebDUser } from "./models/WebDUser";

export const loginWebdUser = async (): Promise<WebDUser> => {
  const response = await apiClient.get("Auth/ciamlogin");
  localStorage.setItem("webDUser", JSON.stringify(response.data));
  return new WebDUser(response.data);
};
